export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden pt-16">
      <div className="absolute inset-0 bg-background-50">
        <div className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: 'radial-gradient(circle at 25% 25%, #2FA84F 1px, transparent 1px), radial-gradient(circle at 75% 75%, #37A9E0 1px, transparent 1px), radial-gradient(circle at 50% 50%, #F4D13D 1px, transparent 1px)',
            backgroundSize: '60px 60px, 80px 80px, 70px 70px',
          }}
        />
        <div className="absolute top-20 right-0 w-[600px] h-[600px] rounded-full opacity-[0.04]" style={{ background: 'radial-gradient(circle, #2FA84F, transparent 70%)' }} />
        <div className="absolute bottom-10 left-10 w-[400px] h-[400px] rounded-full opacity-[0.04]" style={{ background: 'radial-gradient(circle, #37A9E0, transparent 70%)' }} />
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[500px] h-[500px] rounded-full opacity-[0.03]" style={{ background: 'radial-gradient(circle, #F4D13D, transparent 70%)' }} />
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary-300/30 to-transparent" />
      </div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-10 pt-7 md:pt-14 pb-16 md:pb-24">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="animate-fade-in-up">
            
            <div className="mb-5">
              <img
                src="https://static.readdy.ai/image/ff63a95a3d068db59710e28833339873/473109dd943942010dc73e384d113dfa.png"
                alt="AK Energy logo"
                className="h-48 md:h-60 w-auto"
                loading="eager"
              />
            </div>

            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-50 border border-primary-200/50 mb-6">
              <div className="w-2 h-2 rounded-full bg-primary-500 animate-pulse-soft" />
              <span className="text-xs font-semibold text-primary-700 tracking-wide uppercase whitespace-nowrap">Australia's Energy Marketplace</span>
            </div>

            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.08] mb-5" style={{ color: '#111827' }}>
              Australia&rsquo;s<br />
              Trusted Renewable<br />
              <span className="relative">
                Energy Marketplace
                <span className="absolute -bottom-1 left-0 right-0 h-3 md:h-4 rounded-full opacity-25" style={{ background: '#F4D13D' }} />
              </span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 leading-relaxed mb-4 max-w-lg">
              Discover, compare and connect with trusted renewable energy providers offering solar, wind and hydrogen solutions for homes, businesses and communities across Australia.
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-8 max-w-lg">
              AK Energy is Australia&rsquo;s trusted renewable energy marketplace, connecting customers, businesses and renewable energy providers to accelerate the transition towards cleaner energy solutions.
            </p>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="#contact"
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-7 py-3.5 text-sm font-semibold rounded-xl bg-foreground-950 text-white hover:bg-foreground-800 transition-all duration-200 cursor-pointer"
              >
                Find Renewable Energy Solutions
                <i className="ri-arrow-right-line text-lg"></i>
              </a>
              <a
                href="#solar-calculator"
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-7 py-3.5 text-sm font-semibold rounded-xl bg-primary-500 text-white hover:bg-primary-600 transition-all duration-200 cursor-pointer"
              >
                <i className="ri-sun-line text-lg"></i>
                Solar Calculator
              </a>
              <a
                href="#partners"
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-7 py-3.5 text-sm font-semibold rounded-xl border-2 border-foreground-200 text-foreground-800 hover:border-foreground-400 hover:bg-foreground-50 transition-all duration-200 cursor-pointer"
              >
                Become a Verified Energy Provider
                <i className="ri-group-line text-lg"></i>
              </a>
            </div>

            <div className="flex items-center gap-6 mt-10 pt-8 border-t border-background-200/70">
              <div className="flex -space-x-3">
                {['https://readdy.ai/api/search-image?query=Professional%20Australian%20business%20person%20portrait%20headshot%20clean%20studio%20lighting%20neutral%20background%20corporate%20style&width=80&height=80&seq=avt-1&orientation=squarish',
                  'https://readdy.ai/api/search-image?query=Friendly%20Australian%20woman%20portrait%20headshot%20clean%20studio%20lighting%20warm%20natural%20smile%20professional%20style&width=80&height=80&seq=avt-2&orientation=squarish',
                  'https://readdy.ai/api/search-image?query=Confident%20Australian%20professional%20male%20portrait%20headshot%20modern%20studio%20lighting%20clean%20background%20corporate&width=80&height=80&seq=avt-3&orientation=squarish'].map((src, i) => (
                  <div key={i} className="w-10 h-10 rounded-full border-2 border-background-50 overflow-hidden bg-background-200" style={{ zIndex: 3 - i }}>
                    <img src={src} alt="AK Energy community member" className="w-full h-full object-cover" loading="lazy" />
                  </div>
                ))}
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-800">Join 2,000+ Australians</p>
                <p className="text-xs text-foreground-500">already exploring smarter energy</p>
              </div>
            </div>
          </div>

          <div className="relative animate-fade-in hidden lg:block" style={{ animationDelay: '0.3s' }}>
            <div className="relative">
              <div className="absolute -inset-4 rounded-3xl opacity-20 blur-3xl" style={{ background: 'linear-gradient(135deg, #2FA84F, #37A9E0, #F4D13D)' }} />
              <div className="relative bg-white rounded-2xl p-1">
                <img
                  src="https://readdy.ai/api/search-image?query=Premium%203D%20render%20of%20modern%20renewable%20energy%20ecosystem%20with%20sleek%20solar%20panels%20on%20a%20contemporary%20Australian%20home%20roof%20next%20to%20a%20modern%20wind%20turbine%20and%20a%20home%20battery%20storage%20unit%20with%20an%20EV%20car%20charging%20in%20the%20driveway%20clean%20geometric%20design%20style%20soft%20natural%20lighting%20blue%20green%20and%20yellow%20energy%20flow%20lines%20connecting%20everything%20minimalist%20aesthetic%20white%20background&width=1200&height=900&seq=hero-energy-3d&orientation=landscape"
                  alt="AK Energy renewable energy ecosystem showing solar panels, wind turbine, battery storage, and EV charging connected through smart energy technology"
                  className="w-full h-auto rounded-xl"
                  loading="eager"
                />
              </div>

              <div className="absolute -bottom-5 -left-5 bg-white rounded-xl px-4 py-3 flex items-center gap-3 animate-float" style={{ animationDelay: '0.5s' }}>
                <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center">
                  <i className="ri-sun-line text-primary-500 text-xl"></i>
                </div>
                <div>
                  <p className="text-xs font-semibold text-foreground-800">Solar Generation</p>
                  <p className="text-lg font-bold" style={{ color: '#2FA84F' }}>4.2 kWh</p>
                </div>
              </div>

              <div className="absolute -top-4 -right-4 bg-white rounded-xl px-4 py-3 flex items-center gap-3 animate-float-slow" style={{ animationDelay: '1.5s' }}>
                <div className="w-10 h-10 rounded-lg bg-accent-50 flex items-center justify-center">
                  <i className="ri-flashlight-line text-accent-500 text-xl"></i>
                </div>
                <div>
                  <p className="text-xs font-semibold text-foreground-800">Battery Level</p>
                  <p className="text-lg font-bold" style={{ color: '#F4D13D' }}>87%</p>
                </div>
              </div>

              <div className="absolute bottom-8 -right-6 bg-white rounded-xl px-4 py-3 flex items-center gap-3 animate-float" style={{ animationDelay: '2.5s' }}>
                <div className="w-10 h-10 rounded-lg bg-secondary-50 flex items-center justify-center">
                  <i className="ri-windy-line text-secondary-500 text-xl"></i>
                </div>
                <div>
                  <p className="text-xs font-semibold text-foreground-800">Wind Output</p>
                  <p className="text-lg font-bold" style={{ color: '#37A9E0' }}>1.8 MW</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-float-slow hidden md:block">
        <a href="#problem" className="flex flex-col items-center gap-2 text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer">
          <span className="text-xs font-medium tracking-widest uppercase">Scroll</span>
          <div className="w-5 h-8 rounded-full border-2 border-foreground-300 flex items-start justify-center p-1">
            <div className="w-1.5 h-1.5 rounded-full bg-foreground-400 animate-bounce" />
          </div>
        </a>
      </div>
    </section>
  );
}